<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tiposCert">
    <fieldset id="agregar_tiposCert" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                        <div class="form-horizontal titulo">

                            <div class="form-group" align="left">
                                <div class="col-md-12">
                                    <h4>
                                        <label for="tipocert">Certificados:</label>
                                    </h4>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-3">ROL</div>
                                <div class="col-md-3">FOLIO</div>
                                <!-- <div class="col-md-3">ROL</div> -->
                            </div>
                            <div class="form-group" *ngFor="let sol of tipos_certificados; let i = index">
                                <div class="col-md-3">{{sol.rol}}</div>
                                <!-- <div class="col-md-6">{{sol[i].id_direcc}}</div> -->
                                <div class="col-md-3">{{sol.folio}}</div>
                            </div>
                            <br />
                            <div class="form-group">
                                <div class="col-md-6">Tipo Certificado</div>
                                <div class="col-md-3">Monto a Cancelar</div>
                            </div>
                            <div class="form-group" *ngFor="let sol of tipos_certificados; let i = index">
                                <div class="col-md-3">{{sol.rol}}</div>
                                <!-- <div class="col-md-6">{{sol[i].id_direcc}}</div> -->
                                <div class="col-md-3">{{sol.folio}}</div>

                            </div>
                        </div>
                    <br />
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>